import { useEffect, useState } from "react";
import Loader from "../../common/Loader";
import {
  Card,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
  Stack
} from "@mui/material";
import {
  setNolocationcount,
  setNoLocationSites,
  setSelectedsite,
  setSelectlocation,
  setShowaddproject,
  setShowalert,
  setShowReport
} from "../../redux/actions/actions";
import { useDispatch } from "react-redux";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { DELETE_SITES, SAVE_SITES, SITE_ISSUES } from "../../constant/Apipath";
import { useSelector } from "react-redux";
import { Getrequestcall } from "../../request/Getrequest";
import ErrorIcon from "@mui/icons-material/Error";
import { BIGrey, BIRed } from "../../assets/helpers";
import PromptModal from "../common/PromptModal";
import { Postrequestcall } from "../../request/Postrequest";
import { getAddress } from "../../request/Fetchcurrentaddress";
import { English } from "../../constant/EnglishFallback";
import Pages from "../../constant/ReportModel";

export default function Nolocationsites(props) {
  const { loginData, selectLocation, showMapmodal, noLocationSites, multiLanguageData } =
    useSelector((state) => state?.main);

  const [loader, setLoader] = useState(false);
  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(false);
  const [deleteSiteConfirmModalOpen, setDeleteSiteConfirmModalOpen] = useState(false);
  const [selecteSite, setSelectsite] = useState(null);

  const {
    TEXT_NO_LOCATION = English?.Map?.TEXT_NO_LOCATION,
    TEXT_NO_LOCATION_SITE_ALERT = English?.Map?.TEXT_NO_LOCATION_SITE_ALERT,
    TEXT_ADD_LOCATION = English?.Map?.TEXT_ADD_LOCATION,
    BUTTON_ADD_PROJECT = English?.Map?.BUTTON_ADD_PROJECT,
    TEXT_DELETE_SITE = English?.Map?.TEXT_DELETE_SITE,
    TEXT_REPORT = English?.Map?.TEXT_REPORT,
    TEXT_DELETE_SITE_ALERT = English?.Map?.TEXT_DELETE_SITE_ALERT,
    TEXT_DELETE_SITE_DESC_ALERT = English?.Map?.TEXT_DELETE_SITE_DESC_ALERT,
    BUTTON_DELETE = English?.Map?.BUTTON_DELETE
  } = multiLanguageData?.Map || {};

  const dispatch = useDispatch();

  const validValues = [
    "experience",
    "earn-rewards",
    "company-detail",
    "product-detail",
    "manufacture-detail"
  ];

  useEffect(() => {
    if (props.noLocationSites === true) {
      getNolocationsites();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.noLocationSites]);

  useEffect(() => {
    if (selectLocation?.from === "no-location" && selectLocation?.open === false) {
      Savesitewithlocation();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectLocation]);

  const getNolocationsites = async () => {
    setLoader(true);
    try {
      const getResponse = await Getrequestcall(
        SITE_ISSUES + `/${loginData?.userInformation?.UserId}`,
        loginData?.accessToken
      );
      if (getResponse.status === 200) {
        if (getResponse.data?.data?.length > 0) {
          dispatch(setNoLocationSites(getResponse.data?.data ?? []));
          dispatch(setNolocationcount(getResponse.data?.data?.length));
        } else {
          dispatch(setNoLocationSites([]));
          dispatch(setNolocationcount(0));
        }
      }
    } catch (error) {
      // Optionally handle error
    } finally {
      setLoader(false);
    }
  };

  const addLocation = async () => {
    let getCurrentLocation = {
      open: true,
      lat: 0,
      lng: 0,
      from: "no-location"
    };
    dispatch(setSelectlocation(getCurrentLocation));
    setMoreMenuAnchorEl(false);
  };

  const addProject = (e) => {
    dispatch(setSelectedsite({ ...selecteSite, lat: 0, lng: 0 }));
    dispatch(setShowaddproject(true));
    setMoreMenuAnchorEl(false);
  };

  const deleteSite = () => {
    setDeleteSiteConfirmModalOpen(true);
    setMoreMenuAnchorEl(false);
  };

  const addReport = (item) => {
    const reportObj = {
      showReport: true,
      name: Pages?.site?.name,
      AppScreenId: Pages?.site?.id,
      recordId: selecteSite?.id || 0
    };
    dispatch(setShowReport(reportObj));
    setMoreMenuAnchorEl(false);
  };

  const openMenu = (e, item) => {
    e.preventDefault();
    setSelectsite(item);
    setMoreMenuAnchorEl(e.currentTarget);
  };

  const handleNoLocationAlert = () => {
    let alertObj = {
      showAlert: true,
      title: "",
      text: TEXT_NO_LOCATION_SITE_ALERT
    };
    dispatch(setShowalert(alertObj));
  };

  const handleDeleteSite = async () => {
    try {
      const payloadObj = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: false,
        ReturnRecordError: true,
        DeleteList: [
          {
            Id: selecteSite?.id,
            ModifiedBy: loginData?.userInformation?.UserId
          }
        ]
      };
      const getDeleteresponse = await Postrequestcall(
        DELETE_SITES,
        payloadObj,
        loginData?.accessToken
      );

      if (getDeleteresponse.status === 201) {
        setDeleteSiteConfirmModalOpen(false);
        await getNolocationsites();
        // Update count after API call
        const getResponse = await Getrequestcall(
          SITE_ISSUES + `/${loginData?.userInformation?.UserId}`,
          loginData?.accessToken
        );
        if (getResponse.status === 200) {
          if (getResponse.data?.data?.length >= 0) {
            dispatch(setNolocationcount(getResponse.data?.data?.length));
          }
        }
      } else {
        setDeleteSiteConfirmModalOpen(false);
      }
    } catch (err) {
      console.log("handleDeleteSite-> Error While Deleting Site: ", err);
      setDeleteSiteConfirmModalOpen(false);
    }
  };

  const Savesitewithlocation = async () => {
    setLoader(true);
    try {
      const getLocation = await getAddress({
        lat: selectLocation.lat,
        lng: selectLocation.lng
      });
      const getObject = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: selecteSite?.id,
            Name: selecteSite?.name,
            Address: getLocation?.objAddress?.address,
            City: getLocation?.objAddress?.city,
            Province: getLocation?.objAddress?.province,
            PostalCode: getLocation?.objAddress?.postalCode,
            Country: getLocation?.objAddress?.country,
            Latitude: getLocation?.objAddress?.lat ?? 0,
            Longitude: getLocation?.objAddress?.lng ?? 0,
            StartDate: "",
            EndDate: "",
            Active: selecteSite?.isActive,
            RecordStatusId: 1,
            ContractorId: 0,
            JobNo: "",
            ConstructionStatusId: 0,
            ModifiedBy: loginData?.userInformation?.UserId
          }
        ]
      };
      const getResponse = await Postrequestcall(SAVE_SITES, getObject, loginData?.accessToken);
      if (getResponse.status === 201) {
        await getNolocationsites();
        let getCurrentLocation = {
          open: false,
          lat: 0,
          lng: 0,
          from: ""
        };
        dispatch(setSelectlocation(getCurrentLocation));
      }
    } catch (error) {
      console.log("Savesitewithlocation-> Error While Saving Site: ", error);
    } finally {
      setLoader(false);
    }
  };

  const navigateSitedetail = (e, site) => {
    e.preventDefault();
    if (props?.from === "modal") {
      if (validValues.includes(showMapmodal?.from)) {
        if (showMapmodal?.select === "project") {
          props.setShowsitedetail(true);
        } else if (showMapmodal?.select === "site") {
          props.setShowsitedetail(false);
        } else {
          props.setShowsitedetail(true);
        }
      } else {
        props.setShowsitedetail(false);
      }
    } else {
      props.setShowsitedetail(true);
    }
    dispatch(setSelectedsite(site));
    props.setSitetypes(true);
    props?.setShowSiteCardModal(true);
  };

  return (
    <>
      <PromptModal
        isOpen={deleteSiteConfirmModalOpen}
        onClose={() => {
          setMoreMenuAnchorEl(false);
          setDeleteSiteConfirmModalOpen(false);
        }}
        title={TEXT_DELETE_SITE_ALERT}
        desc={TEXT_DELETE_SITE_DESC_ALERT}
        redButtonText={BUTTON_DELETE}
        onRedButtonClick={() => {
          handleDeleteSite();
        }}
      />

      {loader ? (
        <Loader fullScreen={true} />
      ) : (
        <>
          <Menu
            anchorOrigin={{
              vertical: "top",
              horizontal: "right"
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right"
            }}
            anchorEl={moreMenuAnchorEl}
            open={Boolean(moreMenuAnchorEl)}
            onClose={(event) => {
              setMoreMenuAnchorEl(false);
            }}>
            <MenuItem onClick={() => addLocation()} style={{ color: "#083db8" }}>
              {TEXT_ADD_LOCATION}
            </MenuItem>
            <MenuItem onClick={() => addProject()} style={{ color: "#083db8" }}>
              {BUTTON_ADD_PROJECT}
            </MenuItem>
            <MenuItem onClick={() => deleteSite()} style={{ color: "red" }}>
              {TEXT_DELETE_SITE}
            </MenuItem>
            <MenuItem onClick={() => addReport()} style={{ color: "red" }}>
              {TEXT_REPORT}
            </MenuItem>
          </Menu>
          <List sx={{ p: 0.5 }}>
            <Stack spacing={0.5}>
              {noLocationSites?.map((item, index) => {
                return (
                  <Card
                    key={index.toString()}
                    className="pagelist-content"
                    sx={{ marginTop: "0px" }}>
                    <ListItem
                      key={index.toString()}
                      sx={{ m: 0 }}
                      secondaryAction={
                        <>
                          <IconButton onClick={() => handleNoLocationAlert()}>
                            <ErrorIcon fontSize="small" style={{ color: BIRed }} />
                          </IconButton>
                          {showMapmodal?.select !== "site" ||
                            (!validValues.includes(showMapmodal?.from) && (
                              <IconButton onClick={(e) => openMenu(e, item)}>
                                <MoreHorizIcon fontSize="small" />
                              </IconButton>
                            ))}
                        </>
                      }
                      disablePadding>
                      <ListItemButton
                        sx={{ p: 0, pl: 1.5 }}
                        onClick={(e) => navigateSitedetail(e, item)}>
                        <ListItemText primary={item?.name} secondary={TEXT_NO_LOCATION} />
                      </ListItemButton>
                    </ListItem>
                  </Card>
                );
              })}
            </Stack>
          </List>
        </>
      )}
    </>
  );
}
